import { connect } from 'react-redux';
import { CompanySelector } from '../../Components/CompanySelector';

const mapStateToProps = (state, ownProps) => ({
  structureData: state.company.companyStructure,
  ...ownProps,
});

export const CompanySelectorWithData = connect(mapStateToProps)(CompanySelector);
